import { Injectable } from '@angular/core';

@Injectable()
export class ImageService {

  private static readonly URL_BASE = 'assets/images';

  getSmallAlbumCoverImg(artistId: string, albumId: string): string {
    if (!artistId || !albumId) {
      return ImageService.getPlaceholderImageUrl(150, 150, "Loading");
    }
    return `${ImageService.URL_BASE}/albums/${artistId}/${albumId}_front_250.jpg`;
  }

  getLargeAlbumCoverImg(artistId: string, albumId: string): string {
    if (!artistId || !albumId) {
      return ImageService.getPlaceholderImageUrl(300, 300, "Loading");
    }
    return `${ImageService.URL_BASE}/albums/${artistId}/${albumId}_front_500.jpg`;
  }

  getArtistImg(artistId: string): string {
    return `${ImageService.URL_BASE}/artists/${artistId}.jpg`;
  }

  static getPlaceholderImageUrl(width: number, height: number, text: string): string {
    return `https://dummyimage.com/${width}x${height}/ccc/000.jpg&text=${text}`;
  }
}
